import "../../styles/globals.css";
import { ApolloProvider } from "@apollo/client";
import { Layout } from "../components/layout";
import { client } from "../apollo";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { LoadingPage } from "../components/LoadingPage";
import { DefaultSEO } from "../components/app/DefaultSEO";
import { ShopProvider } from "../context/ShopContext";

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const handleStart = () => setPageLoading(true);
    const handleComplete = () => setPageLoading(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, []);

  return (
    <ApolloProvider client={client}>
      <DefaultSEO />
      <ShopProvider>
        <Layout>
          {pageLoading ? <LoadingPage /> : <Component {...pageProps} />}
        </Layout>
      </ShopProvider>
    </ApolloProvider>
  );
}

export default MyApp;
